import React from 'react';

import { ReactComponent as Icon } from 'assets/icons/notification_icon.svg';
import { Link } from 'react-router-dom';

import { getUserLS } from 'shared/localStorage';

import styles from './NotificationCenter.module.scss';

const me = JSON.parse(getUserLS());

const SingleNotification = ({ data }) => {
    const showNotificationTime = (dateISO) => {
        const notificationDate = new Date(dateISO).getTime();
        const now = new Date().getTime();

        const difference = now - notificationDate;

        const seconds = parseInt(Math.floor(difference / 1000));
        const minutes = parseInt(Math.floor(seconds / 60));
        const hours = parseInt(Math.floor(seconds / 3600));
        const days = parseInt(Math.floor(seconds / 86400));

        if (days >= 1) {
            return `${days}d`;
        } else if (hours >= 1) {
            return `${hours}h`;
        } else if (minutes >= 1) {
            return `${minutes}m`;
        } else if (seconds > 1) {
            return `Just now`;
        }
    };

    let linkTo = () => {};
    if (data && data.type) {
        switch (data.type) {
            case 'correspondence_match':
            case 'correspondence_move':
            case 'correspondence_time_running_out':
            case 'correspondence_game_over':
                linkTo = `/correspondence/${data.data.game_id}`;
                break;
            case 'new_badge':
                linkTo = `/achievements/${me && me.id}`;
                break;
            case 'game_analysis_done':
                linkTo = `/post-game-analysis/${data.data.game_id}`;
                break;
            default:
                break;
        }
    }

	// eslint-disable-next-line
    console.log('data', data);

    return (
        <div className={styles.single_notification}>
            <Link to={linkTo}>
                <div className={styles.img}>
                    {data && data.from ? (
                        <>
                            {data && data.from && data.from.avatar ? (
                                <img src={data.from.avatar} alt="" />
                            ) : (
                                <img
                                    src={require(`assets/icons/skill_levels/${data.from.level}.png`)}
                                    alt=""
                                />
                            )}
                        </>
                    ) : data && data.type === 'new_badge' ? (
                        <img src={data.data.badge.image} alt="" />
                    ) : (
                        <img
                            src={require('assets/images/avatar_k_chess.png')}
                            alt=""
                        />
                    )}
                </div>
                <div className={styles.not_info}>
                    <p className={styles.context}>{data.message}</p>
                    <div className={styles.notify_footer}>
                        <div className={styles.notify_footer_wrapper}>
                            <Icon />
                            <div className={styles.time}>
                                {showNotificationTime(data.created)}
                            </div>
                            {data && data.data && data.data.cta && (
                                <div className={styles.dot_game}>
                                    <div className={styles.dot}></div>
                                    <span className={styles.go_to_game}>
                                        {data.data.cta}
                                    </span>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </Link>
        </div>
    );
};

export default SingleNotification;
